var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.093 4.863a3.39 3.39 0 0 1 3.859 1.598l6.144 10.87c.46.816.547 1.74.315 2.576a3.39 3.39 0 0 1-3.266 2.483H6.854a3.38 3.38 0 0 1-2.396-.993 3.39 3.39 0 0 1-.554-4.065l6.144-10.87a3.38 3.38 0 0 1 2.044-1.6z",
    stroke: "#FF4D63",
    strokeWidth: 1.22
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#FF4D63",
    fill: "#FF4D63",
    x: 12.5,
    y: 8.5,
    width: 1,
    height: 8,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FF4D63",
    cx: 13,
    cy: 19,
    r: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert-icon.6c341a457c5147593b2e55ac23e23aa1.svg";
export { ForwardRef as ReactComponent };